import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ReportsService } from '../../../services/index';
import * as XLSX from 'xlsx';
import * as moment from 'moment';

@Component({
    selector: 'recheckup-history',
    templateUrl: './recheckupHistory.component.html'
})
export class RecheckupHistoryComponent implements OnInit {
    isLoadMask: Promise<any>;
    historyData: any[] = [];
    totCnt: number = 0;
    clientName: string = '';
    clientNo: string   = '';
    mobile: string     = '';

    columns = [
        { name: 'Recheckup Date',        prop: 'recheckup_date',        width: 120, minWidth: 120, maxWidth: 120, sortable: false },
        { name: 'Recheckup Description', prop: 'recheckup_description', width: 320, minWidth: 320, maxWidth: 320, sortable: false },
        { name: 'Recheckup Status',      prop: 'recheckup_status',      width: 140, minWidth: 140, maxWidth: 140, sortable: false },
        { name: 'Next Conv. Date',       prop: 'next_date',             width: 120, minWidth: 120, maxWidth: 120, sortable: false },
        { name: 'Next Conv. Status',     prop: 'next_status',           width: 160, minWidth: 160, maxWidth: 160, sortable: false },
        { name: 'Next Conv. Description',prop: 'next_description',      width: 320, minWidth: 320, maxWidth: 320, sortable: false }
    ];

    private _clientId: any;

    @Input() set showRecheckupHistory(val: any) {
        this._clientId = val;
        if (val && val.client_id) {
            this.loadHistory(val.client_id);
        }
    }

    constructor(public bsModalRef: BsModalRef, private reportsService: ReportsService) {}

    ngOnInit() {}

    loadHistory(clientId: any) {
        this.isLoadMask = this.reportsService.getRecheckupHistory({ client_id: clientId })
            .then((res: any) => {
                if (res.success) {
                    this.historyData = res.data || [];
                    this.totCnt = res.totCnt || 0;
                    this.clientName = res.client_name || '';
                    this.clientNo   = res.client_no   || '';
                    this.mobile     = res.mobile      || '';
                }
            });
    }

    exportExcel() {
        const headers = [
            'Recheckup Date', 'Recheckup Description', 'Recheckup Status',
            'User', 'Employee',
            'Next Conv. Date', 'Next Conv. Status', 'Next Conv. Description'
        ];
        const dataRows = this.historyData.map(r => [
            r.recheckup_date        || '',
            r.recheckup_description || '',
            r.recheckup_status      || '',
            r.user_name             || '',
            r.emp_name              || '',
            r.next_date             || '',
            r.next_status           || '',
            r.next_description      || ''
        ]);
        const sheetData = [
            ['Client No',   this.clientNo,   'Client Name', this.clientName, 'Phone No', this.mobile],
            [],
            headers,
            ...dataRows
        ];
        const ws = XLSX.utils.aoa_to_sheet(sheetData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Recheckup History');
        XLSX.writeFile(wb, 'RecheckupHistory_' + moment().format('DD-MM-YYYY') + '.xlsx');
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/reports/recheckupHistory/recheckupHistory.component.ts